import { BaseModel } from './base.model';
import { UnconformityModel } from './unconformity.model';
import { InspectionPlanModel } from './inspection-plan.model';

export class ChecklistInspectionModel extends BaseModel {

    weight: number;
    verify?: number;
    keep_status?: number;
    checklist_id: number;
    inspection_plan_id: number;

    inspection_plan: InspectionPlanModel;
    unconformities: UnconformityModel[];

    constructor(model?: ChecklistInspectionModel) {
        super();

        this.weight = model ? model.weight || null : null;
        this.verify = model ? model.verify || null : null;
        this.keep_status = model ? model.keep_status || null : null;
        this.checklist_id = model ? model.checklist_id || null : null;
        this.inspection_plan_id = model ? model.inspection_plan_id || null : null;

        this.inspection_plan = model ? model.inspection_plan || null : null;
        this.unconformities = model ? model.unconformities || [] : [];
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/checklist-inspection.model.ts